"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@kiltprotocol/utils");
const util_1 = require("@polkadot/util");
function errorCheck(delegationBaseNode) {
    const { id, account, revoked } = delegationBaseNode;
    if (!id) {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_MISSING();
    }
    else if (typeof id !== 'string') {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
    }
    else if (!util_1.isHex(id)) {
        throw utils_1.SDKErrors.ERROR_DELEGATION_ID_TYPE();
    }
    if (!account) {
        throw utils_1.SDKErrors.ERROR_OWNER_NOT_PROVIDED();
    }
    else
        utils_1.DataUtils.validateAddress(account, 'delegationNode owner');
    if (typeof revoked !== 'boolean') {
        throw new TypeError('revoked is expected to be a boolean');
    }
}
exports.default = errorCheck;
